import { useEffect, useRef } from 'react';

export function useRunOnce(key, effect) {
    const lastKeyRef = useRef();

    useEffect(() => {
        if (lastKeyRef.current === key) return;
        lastKeyRef.current = key;
        effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
}
